import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { templateSchema } from '../schemas/template.schema';

/**
 * Gets all templates in an account
 * @returns Array of templates
 */
export function getTemplates(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(mapManagementServiceEnvironment.resolve(this).templatesUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(templateSchema)));
}
